import React, { FC, HTMLAttributes } from "react";
import { ElSection } from "./sections.css";

interface ISectionProps extends HTMLAttributes<HTMLElement> {}

export const Section: FC<ISectionProps> = ({ children, ...props }) => {
  return <ElSection {...props}>{children}</ElSection>;
};
